module.exports = __webpack_public_path__ + "assets/images/JMDUNFIT500.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/JMDUNFIT500.png
// module id = 1406
// module chunks = 1